import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useAgentRuntime, useAgentStore } from '@/context/AgentProvider'
import { mapPersistedStatusToUiStatus } from '@/state/useAgentStore'

/**
 * When activeChatId is set but the chat is not in state.chats (e.g. it's on an
 * unfetched page of the list, or from URL/deep link), fetch the chat by ID.
 */
export const useEnsureActiveChat = () => {
  const runtime = useAgentRuntime()
  const activeChatId = useAgentStore((state) => state.activeChatId)
  const upsertChat = useAgentStore((state) => state.upsertChat)
  const setActiveChat = useAgentStore((state) => state.setActiveChat)
  const setChatStatus = useAgentStore((state) => state.setChatStatus)

  const isMissing = Boolean(activeChatId)

  const query = useQuery({
    queryKey: ['mp-agents', 'chat', activeChatId],
    queryFn: () => runtime.transport.getChat(activeChatId!),
    enabled: isMissing,
    staleTime: 60_000,
    retry: false
  })

  useEffect(() => {
    if (query.data) {
      upsertChat(query.data)
      setChatStatus(query.data.id, mapPersistedStatusToUiStatus(query.data.status))
    }
  }, [query.data, upsertChat, setChatStatus])

  useEffect(() => {
    if (query.isError && activeChatId) {
      setActiveChat(undefined)
    }
  }, [query.isError, activeChatId, setActiveChat])

  return query
}
